import { useQueryString } from 'hooks';
import {
  Container,
  CreatorsLogo,
  LogoStyled
} from './styles';

import Creators from 'assets/brand/creators.svg';
import NewCreators from 'assets/brand/flixxo-primary.svg';
import LogoPlay from 'assets/brand/flixxo-white.svg';


const Logo = ({
  scale = 1,
  className,
  theme = 'dark',
  addCreators,
  to = '/',
}) => {

  const { from } = useQueryString()

  const containerProps = from === 'webview'
    ? { as: 'div' }
    : { to }

  const srcLogo = theme === 'light'
    ? NewCreators
    : LogoPlay


  return (
    <Container
      {...containerProps}
      scale={scale}
      className={className}
      $marginBottom={addCreators ? -5 : 0}
    >
      <LogoStyled
        src={srcLogo}
        alt='Flixxo logo'
      />

      {addCreators && (
        <CreatorsLogo
          src={Creators}
          alt='Creators logo'
        />
      )}
    </Container>
  )
};

export default Logo;